import { useMemo } from 'react';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { Context } from 'interface';
import { useLocation } from 'react-router-dom';
import { getSourceDetails } from 'utils/chatUtils';
import ContextAccordionHeader from './ContextAccordionHeader';
import ContextAccordionContent from './ContextAccordionContent';
import CustomContextViewStyle from './CustomContextViewStyle';

const ContextPanel = ({ botDetail: botDetails, botResponse }) => {
    const fullScreen = 'false';
    const contexts = botResponse.answers[0].context;

    const sortedContexts: Context[] = useMemo(() => {
        return contexts?.sort((a: Context, b: Context) => {
            const aSourceType = a.sourceType.trim()?.toLowerCase();
            const bSourceType = b.sourceType.trim()?.toLowerCase();

            if (aSourceType === 'api') return -1;
            if (bSourceType === 'api') return 1;
            return 0;
        });
    }, [contexts]);

    const firstNonApiContextIndex = useMemo(() => {
        return sortedContexts?.findIndex((context: Context) => context.sourceType.trim()?.toLowerCase() !== 'api');
    }, [sortedContexts]);

    if (fullScreen === 'false') return null;
    if (!botResponse.answers[0].context) return null;

    return (
        <CustomContextViewStyle botDetail={botDetails}>
            <div className="chat-control-rightsidebar">
                <h1>Source Context</h1>
                <Accordion
                    className="field--max"
                    expandIcon="fal fa-circle-plus accordion-icon"
                    collapseIcon="fal fa-circle-minus accordion-icon"
                    activeIndex={firstNonApiContextIndex}>
                    {sortedContexts?.map((context, index) => {
                        const sourceType = context.sourceType.trim()?.toLowerCase();
                        const sourceName = getSourceDetails(botDetails, context)[sourceType];

                        return (
                            <AccordionTab
                                key={index}
                                disabled={sourceType === 'api'}
                                header={<ContextAccordionHeader sourceType={sourceType} sourceName={sourceName} />}>
                                {sourceType !== 'api' && <ContextAccordionContent context={context} />}
                            </AccordionTab>
                        );
                    })}
                </Accordion>
            </div>
        </CustomContextViewStyle>
    );
};

export default ContextPanel;
